import { useEffect } from "react";
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { fetchCategoryApiData, fetchProductApiData } from "../../../reduxToolkit/reducers/productSlice";
import AboutUs from "./AboutUs";
import Blogs from "./Blogs";
import CarHomeSection from "./CarHomeSection";
import FeaturedCar from "./FeaturedCar";
import LogoSection from "../common/LogoSection";
import Service from "./Service";
import StepBooking from "./StepBooking";
import TabSection from "./TabSection";
import Categories from "../common/Categories";
import Testimonials from "../common/Testimonials";
import InstagramSlider from "./InstagramSlider";

const CarDemo2Container = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductApiData());
    dispatch(fetchCategoryApiData());
  }, [dispatch]);
  return (
    <>
      <CarHomeSection />
      <TabSection />
      <LogoSection swiperClass="logo-car2-slider" sectionClass="section-t-lg-space" />
      <AboutUs />
      <Categories type={"car_demo2"} />
      <FeaturedCar />
      <StepBooking />
      <Service />
      <Blogs />
      <Testimonials type={"car_demo2"} />
      <InstagramSlider />
    </>
  );
};

export default CarDemo2Container;
